import { render, staticRenderFns } from "./PremiumPlan.vue?vue&type=template&id=2a9701b1&"
import script from "./PremiumPlan.vue?vue&type=script&lang=js&"
export * from "./PremiumPlan.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports